import cx from 'classnames';

import AuthButton from './AuthButton';

import { usePromoStore } from '../../store/userPromoStore';

import { buildAuthLink } from '../../utils/common.js';

const AuthButtons = ({
	text = 'Авторизуйтесь',
	className = '',
	classNameTitle = '',
	classNameButton = '',
	href = {
		vk: null,
		steam: null,
	},
}) => {
	const promo = usePromoStore((s) => s.promo);

	const linkToSteam = buildAuthLink('steam', promo?.h);
	const linkToVk = buildAuthLink('vk', promo?.h);

	return (
		<div className={cx('auth-buttons', { [className]: className })}>
			<a
				href={href.steam ?? linkToSteam}
				className={cx('auth-title', { [classNameTitle]: classNameTitle })}
			>
				{text}
			</a>

			<AuthButton
				href={href.vk ?? linkToVk}
				icon='vk'
				className={cx({ [classNameButton]: classNameButton })}
			/>
			<AuthButton
				href={href.steam ?? linkToSteam}
				icon='steam1'
				className={cx({ [classNameButton]: classNameButton })}
			/>
		</div>
	);
};

export default AuthButtons;
